<script setup lang="ts">
import { moduleName } from '@/enums/moduleNames';
import { getCachedGuestViewResearchMonthly, getCachedGuestViewResearchSevenDay, getCachedGuestViewResearchYearly, getCachedUserViewResearchMonthly, getCachedUserViewResearchSevenDay, getCachedUserViewResearchYearly } from '@/service/analytics/basicAnalytics';
import { userPermissionStore } from '@/stores/user/permission';
import type { AxiosResponse } from 'axios';
import moment from 'moment';
import { computed, onMounted, reactive, ref, type Ref } from 'vue';
import BarChart from '../charts/barChart.vue';
import linearLoadingCard from '../loading/linearLoadingCard.vue';

interface totalViewRecord {
  total: number, 
  target_date: Date,
  action: string
}

enum period {
  SEVENDAY = 'SEVENDAY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

const periodState = ref<period>(period.SEVENDAY)

interface dataset {
  label: string,
  data: number[],
  backgroundColor: string
}

const periodCounter = ref<number>(0)

var sortableCount = 2

const chartData = reactive({
  labels: [] as string[],
  researchDataUser: {label: 'Has Signed In', data: [], backgroundColor: '#8AB8F5', maxBarThickness: 50} as dataset,
  researchDataNonUser: {label: 'Not SIgned In', data: [], backgroundColor: '#4198D3', maxBarThickness: 50} as dataset,
})
const chartDataSevenDays = reactive({
  labels: [] as string[],
  researchDataUser: {label: 'Has Signed In', data: [], backgroundColor: '#8AB8F5', maxBarThickness: 50} as dataset,
  researchDataNonUser: {label: 'Not SIgned In', data: [], backgroundColor: '#4198D3', maxBarThickness: 50} as dataset,
})
const chartDataMonthly = reactive({
  labels: [] as string[],
  researchDataUser: {label: 'Has Signed In', data: [], backgroundColor: '#8AB8F5', maxBarThickness: 50} as dataset,
  researchDataNonUser: {label: 'Not SIgned In', data: [], backgroundColor: '#4198D3', maxBarThickness: 50} as dataset,
})
const chartDataYearly = reactive({
  labels: [] as string[],
  researchDataUser: {label: 'Has Signed In', data: [], backgroundColor: '#8AB8F5', maxBarThickness: 50} as dataset,
  researchDataNonUser: {label: 'Not SIgned In', data: [], backgroundColor: '#4198D3', maxBarThickness: 50} as dataset,
})

// const dataSets = ref<dataset[]>([])
// const labels = ref<string[]>([])

// // const researchCollection = ref<{label: string, value: number}[]>([])
// // const insightCollection = ref<{label: string, value: number}[]>([])

// interface mergedData {
//   label:string[]
//   mergedData: number[]
// }

const userPermission = userPermissionStore()

const totalViewNonUserResearch = ref<totalViewRecord[]>([])
const totalViewUserResearch = ref<totalViewRecord[]>([])
const totalViewUserInsight = ref<totalViewRecord[]>([])
const totalViewNonUserInsight = ref<totalViewRecord[]>([])
// const totalViewMergedResearch = ref<totalViewRecord[]>([])
// const totalViewMergedInsight = ref<totalViewRecord[]>([])

const fetchState = reactive({
  fetchingTotalViewSignedInUserForResearchInSevenDaysBack: true,
  fetchingTotalViewNonUserForResearchInSevenDaysBack: true,
  // fetchingTotalViewSignedInUserForInsightInSevenDaysBack: true,
  // fetchingTotalViewNonUserForInsightInSevenDaysBack: true,
  dataSorted: false,
})

// function mergeAll (){
//   for (var x = 0; x < insightCollection.value.length; x++) {
//     var assigned = false
//     for(var y = 0; y < labels.value.length; y++) {
//       if (moment(labels.value[y]).isBefore(moment(insightCollection.value[x].label))) {
//         labels.value.push(insightCollection.value[x].label)
//         chartData.researchDataNonUser.data.push(insightCollection.value[x].value)
//         assigned = true
//         break
//       } else if (labels.value[y] === insightCollection.value[x].label) {
//         chartData.researchDataNonUser.data.splice(y-1, 0, insightCollection.value[x].value)
//         assigned = true
//         break
//       } else if (y === 0 && moment(labels.value[y]).isAfter(moment(insightCollection.value[x].label))) {
//         chartData.researchDataNonUser.data.unshift(insightCollection.value[x].value)
//         labels.value.unshift(insightCollection.value[x].label)
//         assigned = true
//         break
//       }
//     }
//     if (!assigned) {
//       labels.value.push(insightCollection.value[x].label)
//       chartData.researchDataNonUser.data.push(insightCollection.value[x].value)
//     }
//   }
// }

// function mergeTotalViewResearch () {
//   if (
//     !fetchState.fetchingTotalViewNonUserForResearchInSevenDaysBack && !fetchState.fetchingTotalViewSignedInUserForResearchInSevenDaysBack
//   ) {
//     const data: {label: string, value: number}[] = []

//     for (var x = 0; x < totalViewUserResearch.value.length; x++) {
//       data.push({label: totalViewUserResearch.value[x].target_date.toString(), value: totalViewUserResearch.value[x].total})
//     }

//     for (var y = 0; y < totalViewNonUserResearch.value.length; y++) {
//       var assigned: Boolean = false
//       for(var z = 0; z < data.length; z++) {
//         if (totalViewNonUserResearch.value[y].target_date.toString() === data[z].label) {
//           data[z].value = data[z].value + totalViewNonUserResearch.value[y].total
//           assigned = true
//           break
//         }
//         else if (z === 0 && moment(totalViewNonUserResearch.value[y].target_date).isBefore(moment(data[z].label))) {
//           data.unshift({label: totalViewNonUserResearch.value[y].target_date.toString(), value: totalViewNonUserResearch.value[y].total})
//         }
//         else if (z > 0 && moment(totalViewNonUserResearch.value[y].target_date).isBefore(moment(data[z].label))) {
//           data.splice(z-1, 0, {label: totalViewNonUserResearch.value[y].target_date.toString(), value: totalViewNonUserResearch.value[y].total})
//         }
//       }
//       if (!assigned) {
//         data.push({label: totalViewNonUserResearch.value[y].target_date.toString(), value: totalViewNonUserResearch.value[x].total})
//       }
//     }

//     researchCollection.value = data
//     fetchState.researchPopulated = true
//     if (fetchState.insightPopulated) {
//       mergeAll()
//     }
//   }
// }
// function mergeTotalViewInsight () {
//   if (
//     !fetchState.fetchingTotalViewNonUserForInsightInSevenDaysBack && !fetchState.fetchingTotalViewSignedInUserForInsightInSevenDaysBack
//   ) {
//     const data: {label: string, value: number}[] = []

//     for (var x = 0; x < totalViewUserInsight.value.length; x++) {
//       data.push({label: totalViewUserInsight.value[x].target_date.toString(), value: totalViewUserInsight.value[x].total})
//     }

//     for (var y = 0; y < totalViewNonUserInsight.value.length; y++) {
//       var assigned: Boolean = false
//       for(var z = 0; z < data.length; z++) {
//         if (totalViewNonUserInsight.value[y].target_date.toString() === data[z].label) {
//           data[z].value = data[z].value + totalViewNonUserInsight.value[y].total
//           assigned = true
//           break
//         }
//         else if (z === 0 && moment(totalViewNonUserInsight.value[y].target_date).isBefore(moment(data[z].label))) {
//           data.unshift({label: totalViewNonUserInsight.value[y].target_date.toString(), value: totalViewNonUserInsight.value[y].total})
//         }
//         else if (z > 0 && moment(totalViewNonUserInsight.value[y].target_date).isBefore(moment(data[z].label))) {
//           data.splice(z-1, 0, {label: totalViewNonUserInsight.value[y].target_date.toString(), value: totalViewNonUserInsight.value[y].total})
//         }
//       }
//       if (!assigned) {
//         data.push({label: totalViewNonUserInsight.value[y].target_date.toString(), value: totalViewNonUserInsight.value[x].total})
//       }
//     }
//     insightCollection.value = data
//     fetchState.insightPopulated = true
//     if (fetchState.researchPopulated) {
//       mergeAll()
//     }
//   }
// }

function sortLabelDate (arr: { total: number; target_date: Date; action: string}[], reset: boolean = false) {
  if (reset ) {
    chartData.labels = []
  }
  for (var x = 0; x < arr.length; x++) {
    var assigned = false
    const targetedDate = arr[x].target_date.toString()
    if (chartData.labels.length === 0) {
      chartData.labels.unshift(targetedDate)
      assigned = true
      continue
    }
    if (chartData.labels.includes(targetedDate)) {
      assigned = true
      continue
    }
    if (!assigned) {
      chartData.labels.push(arr[x].target_date.toString())
    }
  }
  sortableCount = sortableCount - 1
  if (sortableCount === 0) {
    chartData.labels.sort((a, b) => moment(a).diff(moment(b), 'days'))
    chartData.researchDataNonUser.data = Array(chartData.labels.length).fill(0)
    chartData.researchDataUser.data = Array(chartData.labels.length).fill(0)
    assignedData(totalViewUserResearch, 'user')
    assignedData(totalViewNonUserResearch, 'nonuser')
    fetchState.dataSorted = true
  }
}

function assignedData (refData: Ref, tag: string = '') {
  for (var x = 0; x < chartData.labels.length; x++) {
    var assigned = false
    for (var y = 0; y < refData.value.length; y++) {
      if (refData.value[y].target_date.toString() === chartData.labels[x]) {
        if (tag === 'user') chartData.researchDataUser.data[x] = chartData.researchDataUser.data[x] + refData.value[y].total
        if (tag === 'nonuser') chartData.researchDataNonUser.data[x] = chartData.researchDataNonUser.data[x] + refData.value[y].total
        assigned = true
        break;
      }
      else if (moment(refData.value[y].target_date).isAfter(moment(chartData.labels[x]))) {
        refData.value.splice(y-1, 0, {total: 0, target_date: moment(chartData.labels[x]).toDate(), action: 'ENTER'})
        assigned =  true
        break;
      }
    }
    if (!assigned) {
      refData.value.push({total: 0, target_date: moment(chartData.labels[x]).toDate(), action: 'ENTER'})
    }
  }
}

const compiledLabel = computed(()=> chartData.labels.map((item:string) => moment(item).format((periodState.value === period.MONTHLY) ? 'MMM YYYY' : ((periodState.value === period.YEARLY) ? 'YYYY' : 'DD MMM YYYY') )))



async function fetchTotalViewSignedInUserForResearch(targetPeriod: period) {
  fetchState.fetchingTotalViewSignedInUserForResearchInSevenDaysBack = true
  var result = {} as AxiosResponse
  if (targetPeriod === period.SEVENDAY) {
    result = (await getCachedUserViewResearchSevenDay())
  } else if (targetPeriod === period.MONTHLY) {
    result = (await getCachedUserViewResearchMonthly())
  } else if (targetPeriod === period.YEARLY) {
    result = (await getCachedUserViewResearchYearly())
  }
  if (periodState.value === targetPeriod) {
    totalViewUserResearch.value = result.data.data
    periodCounter.value = periodCounter.value + 1
    sortLabelDate(result.data.data, periodCounter.value === 1)
  }
  // totalPublishedNews.value = result.data.data.total
  fetchState.fetchingTotalViewSignedInUserForResearchInSevenDaysBack = false
}
async function fetchTotalViewNonUserForResearch(targetPeriod: period) {
  fetchState.fetchingTotalViewNonUserForResearchInSevenDaysBack = true
  var result = {} as AxiosResponse
  if (targetPeriod === period.SEVENDAY) {
    result = (await getCachedGuestViewResearchSevenDay())
  } else if (targetPeriod === period.MONTHLY) {
    result = (await getCachedGuestViewResearchMonthly())
  }else if (targetPeriod === period.YEARLY) {
    result = (await getCachedGuestViewResearchYearly())
  }
  if (periodState.value === targetPeriod) {
    totalViewNonUserResearch.value = result.data.data
    periodCounter.value = periodCounter.value + 1
    sortLabelDate(result.data.data, periodCounter.value === 1)
  }
  fetchState.fetchingTotalViewNonUserForResearchInSevenDaysBack = false
}
async function refetchData(targetPeriod: period) {
  if (userPermission.getUserPermission.read_action.includes(moduleName.ALGO_RESEARCH_ANALYTIC)) {
    periodState.value = targetPeriod
    fetchState.dataSorted = false
    sortableCount = 2
    chartData.labels = []
    chartData.researchDataNonUser.data = []
    chartData.researchDataUser.data = []
    periodCounter.value = 0
    fetchTotalViewSignedInUserForResearch(periodState.value)
    fetchTotalViewNonUserForResearch(periodState.value)
  }
}

onMounted(async ()=> {
  if (userPermission.getUserPermission.read_action.includes(moduleName.ALGO_RESEARCH_ANALYTIC)) {
    refetchData(periodState.value)
  }
})
</script>
<template>
  <div class="flex flex-col bg-white border-[1px] rounded-[6px] p-[16px] gap-[16px]" v-show="userPermission.getUserPermission.read_action.includes(moduleName.ALGO_RESEARCH_ANALYTIC)" >
      <div class="flex fex-row items-center">
      <div class="text-[20px] font-bold flex-grow">Total View Research</div>
      <div class="w-[16px] h-[16px]">
      </div>
      </div>
      <div class="flex fex-row items-center">
        <button class="text-[14px] flex-grow text-center border-b pb-[1px]" :class="[periodState === period.SEVENDAY ? 'font-bold border-b-2 border-black' : 'border-1']" @click="refetchData(period.SEVENDAY)">Last 7 days</button>
        <button class="text-[14px] flex-grow text-center border-b pb-[1px]" :class="[periodState === period.MONTHLY ? 'font-bold border-b-2 border-black' : 'border-1']" @click="refetchData(period.MONTHLY)">Monthly</button>
        <button class="text-[14px] flex-grow text-center border-b pb-[1px]" :class="[periodState === period.YEARLY ? 'font-bold border-b-2 border-black' : 'border-1']" @click="refetchData(period.YEARLY)">Yearly</button>
      </div>
      <div class="w-full my-[8px]">
      <BarChart v-if="fetchState.dataSorted && (chartData.researchDataNonUser.data.length > 0 || chartData.researchDataUser.data.length > 0)" id="chartViewResearch" :labels="compiledLabel" :datasets="[chartData.researchDataNonUser,chartData.researchDataUser]" />
      <div v-if="!fetchState.dataSorted" class="w-full h-[250px]">
        <linearLoadingCard />
      </div>
      </div>
  </div>
</template>